/**
 * Capabilities tabs for Cloud & Infrastructure service pages.
 */
export const CLOUD_INFRASTRUCTURE_CAPABILITIES_EN = [
  {
    id: 'cloud-development',
    label: 'Cloud development',
    paragraphs: [
      'We build cloud-native applications designed for scalability, resilience, and long-term performance. By leveraging modern cloud platforms and architectures, we ensure your systems can handle growth while maintaining efficiency and reliability.',
      'Our approach focuses on modular design, optimized resource usage, and high availability, enabling your digital products to evolve quickly without compromising stability.',
    ],
  },
  {
    id: 'cloud-migration-optimization',
    label: 'Cloud migration & optimization',
    paragraphs: [
      'We help organizations transition to the cloud through carefully planned migration strategies that minimize disruption and risk. Every step is designed to ensure continuity, performance, and cost control.',
      'Once in the cloud, we continuously optimize infrastructure, workloads, and configurations to improve efficiency, reduce costs, and maintain a strong operational foundation.',
    ],
  },
  {
    id: 'devops',
    label: 'DevOps',
    paragraphs: [
      'We implement DevOps practices that streamline development and operations through automation, monitoring, and continuous delivery pipelines.',
      'By improving collaboration and reducing manual processes, we enable faster releases, higher reliability, and a more predictable development lifecycle.',
    ],
  },
  {
    id: 'gcp-partners',
    label: 'GCP Partners',
    paragraphs: [
      'As Google Cloud Platform specialists, we design and implement solutions tailored to your specific business and technical needs.',
      'From infrastructure setup to advanced cloud services, we help you make the most of GCP with scalable, secure, and high-performing implementations.',
    ],
  },
]

export const CLOUD_INFRASTRUCTURE_CAPABILITIES_PT = [
  {
    id: 'cloud-development',
    label: 'Desenvolvimento cloud',
    paragraphs: [
      'Criamos aplicações cloud-native desenhadas para escalabilidade, resiliência e performance a longo prazo. Ao tirar partido de plataformas e arquiteturas cloud modernas, garantimos que os seus sistemas conseguem crescer mantendo eficiência e fiabilidade.',
      'A nossa abordagem foca-se em design modular, utilização otimizada de recursos e alta disponibilidade, permitindo que os seus produtos digitais evoluam rapidamente sem comprometer estabilidade.',
    ],
  },
  {
    id: 'cloud-migration-optimization',
    label: 'Migração e otimização cloud',
    paragraphs: [
      'Ajudamos organizações a transitar para a cloud através de estratégias de migração cuidadosamente planeadas, minimizando interrupções e risco. Cada etapa é pensada para garantir continuidade, performance e controlo de custos.',
      'Depois da migração, otimizamos continuamente infraestrutura, workloads e configurações para melhorar eficiência, reduzir custos e manter uma base operacional sólida.',
    ],
  },
  {
    id: 'devops',
    label: 'DevOps',
    paragraphs: [
      'Implementamos práticas DevOps que aproximam desenvolvimento e operações através de automação, monitorização e pipelines de entrega contínua.',
      'Ao melhorar a colaboração e reduzir processos manuais, permitimos lançamentos mais rápidos, maior fiabilidade e um ciclo de desenvolvimento mais previsível.',
    ],
  },
  {
    id: 'gcp-partners',
    label: 'Parceiros GCP',
    paragraphs: [
      'Como especialistas em Google Cloud Platform, desenhamos e implementamos soluções ajustadas às necessidades técnicas e de negócio de cada projeto.',
      'Da configuração de infraestrutura a serviços cloud avançados, ajudamos a tirar o máximo partido da GCP com implementações escaláveis, seguras e de elevada performance.',
    ],
  },
]
